import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsMaintenanceJobs, PmsMaintenanceJob } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsMaintenanceJob> useData={usePmsMaintenanceJobs} config={config} />;
};

export default List;
